"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeading = exports.Page = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = _styledComponents.default.div.withConfig({
  displayName: "Page",
  componentId: "w7h773-0"
})(["box-sizing:border-box;width:100%;max-width:1200px;padding:0 15px;margin:0 auto 40px;font-size:14px;"]);

exports.Page = Page;

var PageHeadingWrapper = _styledComponents.default.div.withConfig({
  displayName: "Page__PageHeadingWrapper",
  componentId: "w7h773-1"
})(["display:flex;flex-direction:row;justify-content:space-between;padding-bottom:0.5em;border-bottom:1px solid #ccc;margin:0.67em 0;font-size:14px;@media (max-width:900px){flex-direction:column;align-items:center;border-bottom:none;}"]);

var PageHeadingText = _styledComponents.default.h1.withConfig({
  displayName: "Page__PageHeadingText",
  componentId: "w7h773-2"
})(["margin:0;@media (max-width:900px){display:flex;flex-direction:column;align-items:center;padding-bottom:0.5em;border-bottom:1px solid #ccc;margin-bottom:0.5em;}"]);

var PageControlsWrapper = _styledComponents.default.div.withConfig({
  displayName: "Page__PageControlsWrapper",
  componentId: "w7h773-3"
})(["display:flex;align-items:center;"]);

var PageHeading = function PageHeading(_ref) {
  var children = _ref.children,
      className = _ref.className,
      renderPageControls = _ref.renderPageControls;
  return /*#__PURE__*/_react.default.createElement(PageHeadingWrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(PageHeadingText, null, children), renderPageControls && /*#__PURE__*/_react.default.createElement(PageControlsWrapper, null, renderPageControls()));
};

exports.PageHeading = PageHeading;
PageHeading.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  renderPageControls: _propTypes.default.func
};
PageHeading.defaultProps = {
  className: undefined,
  renderPageControls: undefined
};